export default "__VITE_ASSET__C8uF5H8T__"